<template>
  <!-- 임시적으로 로컬에서만 화면 보이게 변경-->
  <div v-if="mode === 'local'">
    main 메인입니다? {{ mode }}
    <v-btn @click="refresh">signinRefresh</v-btn>
    <v-btn @click="signout">signout</v-btn>
    <router-link :to="{ path: '/signup' }">signup</router-link>
    <br />
    <router-link :to="{ name: 'signup/agreements/service' }">agreements</router-link><br />
    <router-link :to="{ name: 'signup/agreements/nice' }">nice agreements</router-link>
    <br />
    getTokenExpireTime: {{ getTokenExpireTime }} ---
    {{ getTokenExpireTime ? $moment(getTokenExpireTime).format('YYYY-MM-DDTHH:mm:ss') : '' }}
    <br />
    getRefreshTokenExpireTime: {{ getRefreshTokenExpireTime }} ---
    {{
      getRefreshTokenExpireTime
        ? $moment(getRefreshTokenExpireTime).format('YYYY-MM-DDTHH:mm:ss')
        : ''
    }}
    <br />
    <v-btn @click="gotoCertification">소금원 버튼</v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      file: null,
    }
  },
  computed: {
    ...mapState('env', ['mode']),
    ...mapState('auth', ['me', 'info']),
    ...mapState('contract', {
      contractCurrent: 'current',
    }),
    ...mapGetters('auth', ['getTokenExpireTime', 'getRefreshTokenExpireTime']),
    routeTempUpdate() {
      //임시적으로 update로 이동시키는 코드
      if (this.me?.kyc.idCardImageVerified === true && this.contractCurrent?.status === 'started') {
        return true
      }
      return false
    },
  },
  watch: {
    routeTempUpdate(v) {
      if (v === true) {
        this.$router.replace('/earlypay')
      }
    },
  },
  async created() {
    const { secret_token, company_name, business_license_number } = this.$route.query
    if (secret_token) {
      await this.signinSuccess({
        accessToken: secret_token,
        refreshToken: secret_token,
      })
    }

    if (company_name) {
      this.$cookies.set('companyName', company_name, 0)
    }
    if (business_license_number) {
      this.$cookies.set('businessLicenseNumber', business_license_number, 0)
    }
  },
  methods: {
    ...mapActions('auth', ['refresh', 'signout', 'signinSuccess']),
    ...mapActions('document', ['easyLogin', 'getIssueIncomeCertification']),
    async gotoCertification() {
      let confirm
      try {
        const data = await this.easyLogin()
        if (data.errorMessage !== '') {
          const click = await this.$swal.basic.alert({
            showCloseButton: false,
            html: '카카오톡 인증에 오류가 발생하여 고객센터로 문의해주세요',
            confirmButtonText: '완료',
            reverseButtons: true,
          })
          if (click.isConfirmed) {
            this.$router.push({ name: 'test' })
          }
        } else {
          confirm = await this.$swal.basic.confirm({
            html: '카카오톡 인증(연동)이 완료되면 완료버튼을 눌러주세요.',
            cancelButtonText: '취소',
            confirmButtonText: '완료',
          })
          this.file = data
          await this.getIssueIncomeCertification(this.file)
          if (confirm.isConfirmed) {
            const swal = await this.$swal.basic.alert({
              showCloseButton: false,
              html: '서류 발급이 완료되었습니다.',
              confirmButtonText: 'OK',
            })
            if (swal.isConfirmed) {
              this.$router.push({ name: 'test' })
            }
          }
        }
      } catch (e) {
        if (e.status === 400 && confirm.isConfirmed) {
          const errorMessage = e.data.errorMessage
          const swal = await this.$swal.basic.alert({
            showCloseButton: false,
            html:
              '<strong>소득금액증명원 발급에 실패하였습니다.</strong><br/><p style="font-size:80%; font-weight:bold;">발급 실패가 지속될 경우 02-6925-1788로 문의해주세요</p><br/><p style="padding:20px 5px 20px 5px; border:1px solid; font-size:small;">' +
              errorMessage +
              '</p>',
            confirmButtonText: 'OK',
          })
          if (swal.isConfirmed) {
            this.$router.push({ name: 'test' })
          }
        }
      }
    },
  },
}
</script>

<style></style>
